var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pn-score",class:{ healthy: _vm.isHealthy, hazard: _vm.pnHazard }},[_vm._v("\n    "+_vm._s(_vm.pnText)+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }